/**
 * POINT_RESULT (craps) — transparent continue-loop beat between
 * consecutive POINT_ROLLs. Exists ONLY because the engine skips
 * same-state transitions; we need one intermediate state so
 * POINT_ROLL.onPhaseEnter fires again on the way back, which
 * re-authorizes the shooter for the next throw.
 *
 * Server timer is set to ~200ms (TIMERS.pointResultMain) so the
 * continue cycle feels instant — "rolls dice → no decision → roll
 * again" with no perceptible beat.
 *
 * No UI work, no dice cleanup. Dice from the just-completed throw
 * stay on the table; PointRollState's onEnter (with previousState ===
 * POINT_RESULT detection) keeps them there for the next pickup.
 */

import { State } from '../State.js';

export class PointResultState extends State {
  // No onEnter, no onUpdate, no onExit. Pure transitional state.
}
